import {
  JobDetailResponse,
  ScoutJobDetailResponse,
} from '@doda/api-client/aspida/@types';

/**
 * DODASITE-29189 求人詳細_T原稿3点要約表示 ABテストの対象判定
 *
 * T原稿（wcnsId = T）はすべて対象（企画タイプは見ない）
 * 企画書の対象外の企画タイプも振り分けに入るので、分析時に prop62（企画名）で分ける
 * @param jobSearchDetail 求人詳細レスポンス（通常/スカウト）
 * @returns ABテスト対象か
 */
export const isTManuscriptSummaryAbTarget = (
  jobSearchDetail?: JobDetailResponse | ScoutJobDetailResponse | null
): boolean => jobSearchDetail?.job?.wcnsId === 'T';
